// Spacing in the app is multiples of 8
const MULTIPLY_BY = 8;

/**
 * Resolves value to css unit
 * @param value
 * @param unit unit to use, if value is a number
 */
export function resolveCSSUnit(value: string | number, unit = 'px'): string | number {
  const resolved = Number.isNaN(+value) ? value : `${value}${unit}`;
  // eslint-disable-next-line eqeqeq
  return typeof document != 'undefined' ? resolved : resolved.toString();
}

/**
 * Create spacing value in multiples of 8 [consistent spacing throughout app]
 * @param value
 */
export function spacing(value: string | number) {
  const res = Number.isNaN(+value) ? 0 : (value as number);
  return resolveCSSUnit(res * MULTIPLY_BY);
}

/**
 * Create spacing values in multiples of 8 [consistent spacing throughout app] - used for margin, padding
 * @param top
 * @param right
 * @param bottom
 * @param left
 */
export function spacings(top: string | number, right = top, bottom = top, left = right) {
  return `${spacing(top)} ${spacing(right)} ${spacing(bottom)} ${spacing(left)}`;
}
